import { Validators } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  IInputParam,
  SelectInterface,
} from '@sarasanalytics-com/design-system';
// import { IInputField } from 'ag-grid-community/dist/lib/widgets/agAbstractInputField';
import {
  customEmailValidator,
  noWhitespaceValidator,
  phoneNumberValidator,
  workEmailValidation,
} from '../validators/validators';

export const password = (
  supportText: string = '',
  config?: { placeholder?: string; validators?: any[] }
) => {
  return {
    disabled: false,
    value: '',
    required: true,
    params: {
      supportText,
      placeholder: config?.placeholder || 'Password',
      type: 'password',
      validators: [Validators.required, ...(config?.validators || [])],
    },
  };
};
export const inputField = (data: IInput): FormlyFieldConfig => {
  return {
    key: data.key,
    type: 'sa-input',
    className: data.className,
    props: {
      disabled: data.props?.disabled || false,
      value: data.props?.value || '',
      required: data.props?.required || false,
      params: {
        placeholder: data.props?.params?.placeholder || '',
        type: data.props?.params?.type || 'text',
        validators: data.props?.params?.validators || [],
        asyncValidators: data.props?.params?.asyncValidators || [],
        eventListener: data.props?.params?.eventListener || null,
      },
    },
  };
};
export const signupFirstNameProps = (value: string = '') => {
  return {
    disabled: false,
    value,
    required: true,
    params: {
      placeholder: 'First Name',
      type: 'text',
      validators: [Validators.required, noWhitespaceValidator],
    },
  };
};
export const signupLastNameProps = (value: string = '') => {
  return {
    disabled: false,
    value,
    required: true,
    params: {
      placeholder: 'Last Name',
      type: 'text',
      validators: [Validators.required, noWhitespaceValidator],
    },
  };
};
export const signupEmailProps = (value: string = '') => {
  return {
    disabled: false,
    value: value,
    required: true,
    icon: {
      name: 'checkmark',
      show: true,
    },
    params: {
      placeholder: 'Work Email',
      type: 'email',
      icon: {
        name: 'checkmark',
        show: true,
      },
      validators: [Validators.required, customEmailValidator(true)],
      // asyncValidators: [workEmailValidation()],
    },
  };
};
export const signupCompanyProps = (value: string = '') => {
  return {
    disabled: false,
    value,
    required: true,
    params: {
      placeholder: 'Company Name',
      type: 'text',
      validators: [Validators.required, noWhitespaceValidator],
    },
  };
};
export const revenueSizeProps = (options: any = defaultSizeOptions) => {
  return {
    options,
    disabled: false,
    required: true,
    params: {
      label: 'Annual Revenue (USD)',
      supportText: '',
      dropIcon: '../assets/downChevronOutlined.svg',
      dropIconPosition: 'right',
      multiple: false,
      iconPath: '../assets/Frame.svg',
      text: 'chip',
      type: 'regular',
      state: 'primary',
      filling: 'filled',
      iconPosition: 'left',
      placeholder:"Select range"
    },
  };
};

export const productSignupProps = (options: any = defaultProductOptions) => {
  return {
    options,
    disabled: false,
    required: true,
    params: {
      label: 'Product Signing Up for',
      supportText: '',
      dropIcon: '../assets/downChevronOutlined.svg',
      dropIconPosition: 'right',
      multiple: false,
      iconPath: '../assets/Frame.svg',
      text: 'chip',
      type: 'regular',
      state: 'primary',
      filling: 'filled',
      iconPosition: 'left',
      placeholder: 'Select Product Signing Up for'
    },
  };
};

export const setupName = (disabled: boolean = false, value: string = '') => {
  return {
    disabled,
    value,
    params: {
      // placeholder: 'Full Name',
      placeholder: '',
      type: 'text',
    },
  };
};
export const setupEmail = (disabled: boolean = false, value: string = '') => {
  return {
    disabled,
    value,
    icon: {
      show: false,
    },
    params: {
      // placeholder: 'Work Email',
      placeholder: '',
      type: 'email',
    },
  };
};

export const loginEmailProps = (value: string = '') => {
  return {
    disabled: false,
    value: value,
    required: true,
    icon: {
      name: 'checkmark',
      show: false,
    },
    params: {
      placeholder: 'Work Email',
      type: 'email',
      validators: [Validators.required, customEmailValidator(false)],
      // asyncValidators: [workEmailValidation()],
    },
  };
};

export const formLinks = {
  privacyPolicy: `https://sarasanalytics.com/privacy/`,
  termsOfUse: `https://sarasanalytics.com/terms-of-use/`,
  login: (product: string)=>`login?productType=${product}`,
  signup: (product: string)=>`signup?productType=${product}`,
}

export const defaultSizeOptions = [
  { id: 0, name: '<$10M', value: '<$10M' },
  { id: 1, name: '$10M-$50M', value: '$10M-$50M' },
  { id: 2, name: '$50M-$200M', value: '$50M-$200M' },
  { id: 3, name: '$200M+', value: '$200M+' },
];

export const defaultProductOptions = [
  { id: 0, name: 'AI Analyst (Essentials) and AI data team (Enterprise)', value: 'Saras IQ' },
  { id: 1, name: 'ELT Pipeline with 200+ Connectors (Saras Daton)', value: 'Saras Daton' },
  { id: 2, name: 'Other', value: 'other' },
];

export interface IInput {
  key: string;
  className: string;
  props: {
    disabled?: boolean;
    value?: string;
    required?: boolean;
    params?: IInputParam;
  };
}
